import { NgModule } from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { AppComponent } from './app.component'
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http'
import { UiLibraryModule } from './ui-library/ui-library.module'
import { StoreModule } from '@ngrx/store'
import { EffectsModule } from '@ngrx/effects'
import { effects, metaReducers, reducers } from './state'
import { AppRoutingModule } from './app-routing.module'
import { NotFoundComponent } from './not-found/not-found.component'
import { LoginComponent } from './login/login.component'
import { CoreModule } from './core/core.module'
import { ReactiveFormsModule } from '@angular/forms'
import { CaseManagementModule } from './case-management/case-management.module'
import { BUILD_SPECIFIC_MODULES } from '../build-specifics'
import { DEFAULT_DIALOG_CONFIG } from '@angular/cdk/dialog'
import { JobsModule } from './jobs/jobs.module'
import { ResultsModule } from './results/results.module'
import { SharedInterceptor } from './shared/interceptors/shared.interceptor'
import { ClarityModule } from '@clr/angular'

@NgModule({
    declarations: [AppComponent, NotFoundComponent, LoginComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        ReactiveFormsModule,
        StoreModule.forRoot(reducers, {
            metaReducers,
            runtimeChecks: { strictActionWithinNgZone: true, strictActionTypeUniqueness: true },
        }),
        EffectsModule.forRoot(effects),
        ...BUILD_SPECIFIC_MODULES,
        AppRoutingModule,
        UiLibraryModule,
        CoreModule,
        CaseManagementModule,
        ResultsModule,
        JobsModule,
        ClarityModule,
    ],
    bootstrap: [AppComponent],
    providers: [
        {
            provide: DEFAULT_DIALOG_CONFIG,
            useValue: {
                closeOnNavigation: true,
                panelClass: 'default-dialog-container',
                hasBackdrop: true,
                backdropClass: 'default-dialog-backdrop',
            },
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: SharedInterceptor,
            multi: true,
        },
    ],
})
export class AppModule {}
